import React, { Component } from "react";
import { Modal, Form, Row, Col, Button, InputNumber } from "antd";
import InputForm from "./InputForm";
import UsuarioFrame from './UsuarioFrame';
import GrupoFrame from './GrupoFrame';
import ProdutoFrame from './ProdutoFrame';
import "./Form.css";

const { Item: ItemForm } = Form;

export default class UsuarioProdutoForm extends Component {
  state = {
    registro: {
      up_idf: '',
      up_usuario: '',
      up_grupo: '',
      up_item: '',
    }
  };


  componentDidUpdate(propsAnterior, stateAnterior) {
    if (this.props.registroSelecionado !== propsAnterior.registroSelecionado) {
      this.setState({
        registro: this.props.registroSelecionado
      }, () => {
        // this.refs.registro.up_usuario.focus();
      });
    }
  }

  onChange = event => {
    const value = event.target.value;
    const id = event.target.id;
    const { registro } = this.state;
    registro[id] = value;
    this.setState({
      [id]: value
    });
  };

  onChangeVendedor = event => {
    const { registro } = this.state;
    registro['up_usuario'] = event.up_usuario;
    this.setState(event);
  }

  onChangeGrupo = event => {
    const { registro } = this.state;
    registro['up_grupo'] = event.up_grupo;
    this.setState(event);
  }

  onChangeProduto = event => {
    const { registro } = this.state;
    registro['up_item'] = event.up_item;
    this.setState(event);
  }



  onOK = () => {
    const { registro } = this.state;

    if (
      !registro.up_usuario ||
      registro.up_usuario.key === '0' ||
      registro.up_usuario.key === ''
    ) {
      Modal.warning({ title: 'Aviso!', content: 'Informe o Vendedor' });
      return;
    }

    const grupoVazio =
      !registro.up_grupo ||
      registro.up_grupo.key === '0' ||
      registro.up_grupo.key === '';

    const itemVazio =
      !registro.up_item ||
      registro.up_item.key === '0' ||
      registro.up_item.key === '';

    if (grupoVazio && itemVazio) {
      Modal.warning({ title: 'Aviso!', content: 'Informe um Grupo ou Produto' });
      return;
    }

    const registroSalvar = {
      ...registro,
      up_usuario: registro.up_usuario.key,
      up_grupo: registro.up_grupo && registro.up_grupo.key ? registro.up_grupo.key : '',
      up_item: registro.up_item && registro.up_item.key ? registro.up_item.key : '',
    };

    this.props.onSalvarClick(registroSalvar);
  };





  render() {
    const { onCancelarClick, carregando, visivel } = this.props;
    const { up_idf, up_usuario, up_grupo, up_item } = this.state.registro;

    // console.log('UsuarioProdutoForm: ', this.state);

    return (
      <Modal
        title={up_idf ? "Edição de Produto do Vendedor" : "Cadastro de Produto do Vendedor"}
        visible={visivel}
        destroyOnClose
        onCancel={onCancelarClick}
        footer={null}
        width={"40%"}
        style={{ top: 30 }}
      >
        <Form>
          <Row>
            <Col xs={24}>
              <UsuarioFrame
                label="Vendedor"
                id="up_usuario"
                value={up_usuario}
                width={"100%"}
                vendedor={1}
                todasEmpresas={this.state.usuario ? this.state.usuario.emp_codigo : 999999}
                onChange={this.onChangeVendedor}
                descricaoPrimeiroItem="Selecione um Vendedor"
                disabled={up_idf ? true : false}
              />
            </Col>

            <Col xs={24}>
              <GrupoFrame
                label="Grupo Produto"
                id="up_grupo"
                value={up_grupo}
                width={"100%"}
                onChange={this.onChangeGrupo}
                descricaoPrimeiroItem="Selecione um Grupo"
              />
            </Col>

            <Col xs={24}>
              <ProdutoFrame
                label="Produto"
                id="up_item"
                value={up_item}
                width={"100%"}
                onChange={this.onChangeProduto}
                descricaoPrimeiroItem="Selecione um Item"
              />
            </Col>

          </Row>
          <ItemForm>
            <Row>
              <Col xs={24}>
                <Button
                  htmlType="button"
                  loading={carregando}
                  onClick={this.onOK}
                  className="botoesModalForm"
                >
                  Salvar
                </Button>

                <Button
                  htmlType="button"
                  onClick={onCancelarClick}
                  className="botoesModalFecharForm"
                >
                  Cancelar
                </Button>
              </Col>
            </Row>
          </ItemForm>

        </Form>
      </Modal>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/UsuarioProdutoForm.js